import React, { useMemo } from 'react';

import { t } from '@lingui/macro';
import { EmailTemplate } from '~/types/internal-api';
import { Field } from '../../../../../shared/components/Form';

interface Props {
    hidePicker?: boolean;
    templates?: EmailTemplate[];
}

export function EmailTemplatePicker(props: Props) {
    const { hidePicker, templates } = props;

    const placeholderText = t`Choose an e-mail template`;
    const showEmailTemplates = !hidePicker && templates && templates.length > 0;
    const emailTemplatesOptions = useMemo(() => {
        return [
            {
                text: placeholderText,
                value: 0,
            },
            ...(templates || []).map(template => ({
                text: template.name,
                value: template.id,
            })),
        ];
    }, [templates, placeholderText]);

    if (!showEmailTemplates) {
        return null;
    }

    return (
        <Field.Dropdown name="emailTemplate" options={emailTemplatesOptions} label={t`E-mail template`} fieldClassName="w-full" />
    );
}
